import { build13x13GridFromHandFreqMap, parseRangeSpecToFreqMap } from "./rangeParser";

// Positions used in `Solver.js`: lj, hj, co, btn, sb, bb
// Data layout for readability:
// 1) OPENS  -> RFI/open frequencies
// 2) VS_OPEN -> facing an open (call + 3bet)
// 3) VS_3BET -> opener facing a 3bet (call + 4bet)
// 4) VS_OPEN_CALL -> facing open + cold-call (squeeze/call responses)
// 5) VS_4BET -> 3bettor facing a 4bet (call response)

const OPENS = {
  lj: {
    openSizeBb: 2.5,
    spec:
      "55+,44:0.28,33:0.24,22:0.21,A2s+,K5s+,K4s:0.17,Q8s+,Q7s:0.22,J9s+,J8s:0.16,T9s,T8s:0.42,98s:0.52,87s:0.39,76s:0.41,65s:0.38,54s:0.46,A9o:0.57,ATo+,KTo:0.76,KJo+,QTo:0.55,QJo,JTo:0.05,Q7s:0.05,J8s:0.02,T8s:0.11,98s:0.13,87s:0.10,76s:0.06,65s:0.04,54s:0.03,44:0.15,33:0.11,22:0.08,QTo:0.14,KTo:0.21,A9o:0.14",
  },
  hj: {
    openSizeBb: 2.5,
    spec:
      "55+,44:0.28,33:0.24,22:0.21,A2s+,K5s+,K4s:0.17,Q8s+,Q7s:0.22,J9s+,J8s:0.16,T9s,T8s:0.42,98s:0.52,87s:0.39,76s:0.41,65s:0.38,54s:0.46,A9o:0.57,ATo+,KTo:0.76,KJo+,QTo:0.55,QJo,JTo:0.05",
  },
  co: {
    openSizeBb: 2.5,
    spec:
      "55+,44:0.83,33:0.69,22:0.42,A2s+,K4s+,K3s:0.83,Q6s+,Q5s:0.88,J8s+,J7s:0.67,T8s+,T7s:0.24,98s,97s:0.64,87s,86s:0.09,76s:0.56,65s:0.51,54s:0.48,A5o:0.71,A7o:0.23,A8o:0.84,A9o+,K9o:0.32,KTo+,QTo+,J9o:0.07,JTo+,T9o:0.11",
  },
  btn: {
    openSizeBb: 2.5,
    spec:
      "22+,A2s+,K2s+,Q3s+,Q2s:0.19,J5s+,J4s:0.86,T6s+,96s+,86s+,85s:0.14,75s+,65s,64s:0.26,54s,,A3o:0.74,A4o+,K8o:0.58,K9o+,Q9o+,J8o:0.33,J9o+,T8o:0.62,T9o+,98o:0.57",
  },
  sb: {
    openSizeBb: 3.0,
    spec:
      "22+,A2s+,K2s+,Q2s+,J4s+,T6s+,96s+,86s+,85s:0.82,75s+,64s+,54s,53s:0.67,A3o:0.11,A4o+,K8o:0.61,K9o+,Q9o+,J9o+,T8o:0.63,T8o:0.72,T9o+,98o:0.76,87o:0.18",
  },
};

const VS_OPEN = {
  lj: {
    hj: {
      callSpec: null,
      raiseActionLabel: "Raise 7.5",
      raiseSpec:
        "AA,KK,QQ,AKs,AKo,AQs:0.88,AJs:0.39,ATs:0.33,A9s:0.15,A8s:0.19,A7s:0.20,A6s:0.04,A5s:0.72,A4s:0.91,A3s:0.42,A2s:0.06,KQs:0.65,KJs:0.56,KTs:0.42,K9s:0.23,K8s:0.09,K7s:0.09,K5s:0.26,K4s:0.06,QJs:0.012,QTs:0.05,JTs:0.03,T9s:0.01,87s:0.07,76s:0.06,65s:0.14,54s:0.12,JJ:0.53,TT:0.21,99:0.13,88:0.12,77:0.08,66:0.04,55:0.02,AQo:0.44,AJo:0.09,KQo:0.59,KJo:0.04",
    },
    co: {
      callSpec: null,
      raiseActionLabel: "Raise 7.5",
      raiseSpec:
        "AKs,AQs:0.92,AJs:0.42,ATs:0.39,A9s:0.59,A8s:0.74,A7s:0.80,A6s:0.32,A5s:0.68,A4s:0.80,A3s:0.86,A2s:0.83,KQs:0.69,KJs:0.57,KTs:0.51,K9s:0.51,K8s:0.18,K7s:0.29,K5s:0.23,K4s:0.11,QJs:0.72,QTs:0.57,JTs:0.32,T9s:0.08,87s:0.02,76s:0.11,65s:0.10,54s:0.08,AA,KK,QQ,JJ:0.62,TT:0.47,99:0.41,88:0.39,77:0.58,66:0.15,55:0.05,AKo:0.82,AQo:0.55,AJo:0.45,KQo:0.78,KJo:0.14,AKo",
    },
    btn: {
      callSpec:
        "AQs:0.08,AJs:0.58,ATs:0.61,A9s:0.24,A8s:0.17,A7s:0.12,A5s:0.32,A4s:0.20,A3s:0.14,KQs:0.31,KJs:0.43,KTs:0.49,K9s:0.13,QJs:0.28,QTs:0.25,JTs:0.41,T9s:0.12,98s:0.11,87s:0.12,76s:0.19,65s:0.18,54s:0.24,JJ:0.38,TT:0.53,99:0.59,88:0.61,77:0.42,66:0.30,55:0.19,44:0.15,33:0.12,22:0.10,AKo:0.18,AQo:0.45,AJo:0.09,KQo:0.22",
      raiseActionLabel: "Raise 7.5",
      raiseSpec:
        "AKs,AQs:0.92,AJs:0.42,ATs:0.39,A9s:0.59,A8s:0.74,A7s:0.80,A6s:0.32,A5s:0.68,A4s:0.80,A3s:0.86,A2s:0.83,KQs:0.69,KJs:0.57,KTs:0.51,K9s:0.51,K8s:0.18,K7s:0.29,K5s:0.23,K4s:0.11,QJs:0.72,QTs:0.57,JTs:0.32,T9s:0.08,87s:0.02,76s:0.11,65s:0.10,54s:0.08,AA,KK,QQ,JJ:0.62,TT:0.47,99:0.41,88:0.39,77:0.58,66:0.15,55:0.05,AKo:0.82,AQo:0.55,AJo:0.45,KQo:0.78,KJo:0.14",
    },
    sb: {
      callSpec:
        "AQs:0.15,AJs:0.36,ATs:0.43,A9s:0.21,A8s:0.16,A7s:0.06,A5s:0.17,A4s:0.16,A3s:0.12,KQs:0.12,KJs:0.23,KTs:0.30,K9s:0.05,QJs:0.13,QTs:0.18,JTs:0.21,T9s:0.08,98s:0.06,87s:0.05,76s:0.09,65s:0.13,54s:0.10,JJ:0.16,TT:0.28,99:0.41,88:0.31,77:0.25,66:0.22,55:0.14,44:0.12,33:0.11,22:0.10,AKo:0.08,AQo:0.18",
      raiseActionLabel: "Raise 10",
      raiseSpec:
        "AKs,AQs:0.85,AJs:0.64,ATs:0.57,A9s:0.66,A8s:0.26,A7s:0.04,A5s:0.83,A4s:0.84,A3s:0.17,KQs:0.88,KJs:0.77,KTs:0.70,K9s:0.08,QJs:0.87,QTs:0.68,JTs:0.57,T9s:0.24,98s:0.02,87s:0.16,76s:0.17,65s:0.25,54s:0.18,AA,KK,QQ,JJ:0.84,TT:0.72,99:0.59,88:0.53,77:0.41,66:0.16,55:0.06,AKo:0.92,AQo:0.82,AJo:0.14,KQo:0.15",
    },
    bb: {
      callSpec:
        "AQs:0.31,AJs:0.88,ATs:0.82,A9s:0.69,A8s:0.75,A7s:0.74,A6s:0.72,A5s:0.15,A4s:0.49,A3s:0.73,A2s:0.78,KQs:0.08,KJs:0.18,KTs:0.76,K9s:0.83,K8s:0.88,K7s:0.73,K6s:0.77,K5s:0.76,K4s:0.72,K3s:0.35,K2s:0.25,QJs:0.15,QTs:0.31,Q9s:0.72,Q8s:0.74,Q7s:0.23,Q6s:0.21,Q5s:0.10,JTs:0.38,J9s:0.61,J8s:0.70,T9s:0.75,T8s:0.78,T7s:0.86,98s:0.89,97s:0.94,96s:0.96,87s:0.68,86s:0.97,85s:0.48,76s:0.62,75s:0.84,74s:0.18,65s:0.71,64s:0.88,54s:0.73,53s:0.90,52s:0.16,43s:0.74,42s:0.13,JJ:0.45,TT:0.82,99:0.93,88:0.94,77:0.95,66:0.96,55:0.97,44,33,22,AQo:0.85,AJo:0.87,ATo:0.87,KQo:0.78,KJo:0.80,KTo:0.09,QJo:0.72,QTo:0.21,JTo:0.11",
      raiseActionLabel: "Raise 10",
      raiseSpec:
        "AKs,AQs:0.69,AJs:0.12,ATs:0.18,A9s:0.31,A8s:0.25,A7s:0.26,A6s:0.28,A5s:0.85,A4s:0.51,A3s:0.27,A2s:0.22,KQs:0.92,KJs:0.82,KTs:0.24,K9s:0.17,K8s:0.12,K7s:0.27,K6s:0.23,K5s:0.24,K4s:0.28,K3s:0.55,K2s:0.48,QJs:0.85,QTs:0.69,Q9s:0.28,Q8s:0.26,Q7s:0.52,Q6s:0.26,Q5s:0.09,JTs:0.62,J9s:0.39,J8s:0.22,T9s:0.25,T8s:0.22,T7s:0.08,98s:0.11,97s:0.06,87s:0.32,86s:0.03,76s:0.38,75s:0.16,65s:0.29,64s:0.07,54s:0.27,53s:0.10,43s:0.26,AA,KK,QQ,JJ:0.55,TT:0.18,99:0.07,88:0.06,77:0.05,66:0.04,55:0.03,AKo,AQo:0.15,AJo:0.13,ATo:0.13,A5o:0.58,KQo:0.22,KJo:0.20,KTo:0.01,QJo:0.15,QTo:0.01",
    },
  },
  // HJ open reactions mirror LJ open reactions.
  hj: null,
  co: {
    btn: {
      callSpec:
        "AQs:0.19,AJs:0.38,ATs:0.64,A9s:0.22,A8s:0.15,A7s:0.10,A5s:0.34,A4s:0.23,A3s:0.15,KQs:0.36,KJs:0.55,KTs:0.43,K9s:0.21,QJs:0.29,QTs:0.27,JTs:0.58,T9s:0.14,76s:0.09,65s:0.08,54s:0.14,JJ:0.11,TT:0.51,99:0.61,88:0.65,77:0.60,66:0.32,55:0.15,44:0.12,33:0.08,22:0.12,AQo:0.42,AJo:0.22,KQo:0.24",
      raiseActionLabel: "Raise 7.5",
      raiseSpec:
        "AKs,AQs:0.81,AJs:0.62,ATs:0.36,A9s:0.78,A8s:0.73,A7s:0.72,A6s:0.93,A5s:0.66,A4s:0.77,A3s:0.85,A2s:0.55,KQs:0.64,KJs:0.45,KTs:0.57,K9s:0.59,K8s:0.13,QJs:0.71,QTs:0.73,Q9s:0.24,JTs:0.42,T9s:0.16,76s:0.25,65s:0.12,54s:0.23,AA,KK,QQ,JJ:0.89,TT:0.49,99:0.39,88:0.35,77:0.40,66:0.56,55:0.12,AKo,AQo:0.58,AJo:0.78,ATo:0.31,KQo:0.76,KJo:0.34,KTo:0.06,QJo:0.14",
    },
    sb: {
      callSpec:
        "ATs:0.18,A9s:0.16,A8s:0.15,A7s:0.12,A6s:0.04,A5s:0.03,A4s:0.07,A3s:0.06,KQs:0.03,KJs:0.09,KTs:0.13,K9s:0.11,K8s:0.01,QJs:0.05,QTs:0.12,Q9s:0.08,JTs:0.06,J9s:0.09,T9s:0.05,T8s:0.02,98s:0.02,87s:0.02,76s:0.01,54s:0.02,TT:0.06,99:0.12,88:0.15,77:0.18,66:0.19,55:0.10,44:0.04,33:0.05,22:0.04,AQo:0.07,AJo:0.05,ATo:0.03,KQo:0.04,KJo:0.03,KTo:0.01,QJo:0.02",
      raiseActionLabel: "Raise 10",
      raiseSpec:
        "AKs,AQs,AJs:0.95,ATs:0.48,A9s:0.53,A8s:0.07,A7s:0.29,A5s:0.81,A4s:0.84,A3s:0.89,A2s:0.72,KQs:0.95,KJs:0.90,KTs:0.72,K9s:0.45,QJs:0.95,QTs:0.73,JTs:0.23,T9s:0.13,98s:0.04,87s:0.06,76s:0.11,65s:0.12,54s:0.03,AA,KK,QQ,JJ:0.93,TT:0.83,99:0.67,88:0.45,77:0.44,66:0.38,55:0.16,AKo,AQo:0.82,AJo:0.39,KQo:0.67",
    },
    bb: {
      callSpec:
        "AJs:0.83,ATs-A7s,A6s:0.78,A5s:0.35,A4s:0.48,A3s:0.90,A2s:0.72,KQs:0.18,KJs:0.32,KTs:0.68,K9s:0.72,K8s:0.80,K7s:0.83,K6s:0.77,K5s:0.72,K4s:0.62,K3s:0.57,K2s:0.88,QJs:0.21,QTs:0.33,Q9s:0.69,Q8s:0.68,Q7s:0.81,Q6s:0.65,Q5s:0.70,Q4s:0.62,JTs:0.34,J9s:0.41,J8s:0.68,J7s:0.63,T9s:0.36,T8s:0.89,T7s:0.85,T6s:0.16,98s:0.60,97s:0.84,96s:0.83,95s:0.07,87s:0.66,86s:0.96,85s:0.34,76s:0.55,75s,74s:0.11,65s:0.70,64s:0.95,54s:0.62,53s,43s:0.81,TT:0.58,99:0.85,88:0.92,77:0.94,66:0.89,55:0.97,44-22,AQo:0.71,AJo:0.74,ATo:0.75,A9o:0.25,A5o:0.09,KQo:0.67,KJo:0.70,KTo:0.73,QJo:0.72,QTo:0.35,JTo:0.56",
      raiseActionLabel: "Raise 10",
      raiseSpec:
        "AKs,AQs,AJs:0.17,A6s:0.22,A5s:0.65,A4s:0.52,A3s:0.10,A2s:0.28,KQs:0.82,KJs:0.68,KTs:0.32,K9s:0.28,K8s:0.20,K7s:0.17,K6s:0.23,K5s:0.28,K4s:0.38,K3s:0.43,K2s:0.12,QJs:0.79,QTs:0.67,Q9s:0.31,Q8s:0.32,Q7s:0.19,Q6s:0.35,Q5s:0.30,Q4s:0.31,JTs:0.66,J9s:0.59,J8s:0.32,J7s:0.37,T9s:0.64,T8s:0.11,T7s:0.15,98s:0.40,97s:0.16,96s:0.17,87s:0.34,86s:0.04,76s:0.45,65s:0.30,64s:0.05,54s:0.38,43s:0.19,AA,KK,QQ,JJ,TT:0.42,99:0.15,88:0.08,77:0.06,66:0.11,55:0.03,AKo,AQo:0.29,AJo:0.26,ATo:0.25,A9o:0.23,A8o:0.08,A5o:0.16,KQo:0.33,KJo:0.30,KTo:0.27,QJo:0.28,QTo:0.15,JTo:0.11",
    },
  },
  btn: {
    sb: {
      callSpec:
        "ATs:0.18,A9s:0.16,A8s:0.15,A7s:0.12,A6s:0.04,A5s:0.03,A4s:0.07,A3s:0.06,KQs:0.03,KJs:0.09,KTs:0.13,K9s:0.11,K8s:0.01,QJs:0.05,QTs:0.12,Q9s:0.08,JTs:0.06,J9s:0.09,T9s:0.05,T8s:0.02,98s:0.02,87s:0.02,76s:0.01,54s:0.02,TT:0.06,99:0.12,88:0.15,77:0.18,66:0.19,55:0.10,44:0.04,33:0.05,22:0.04,AQo:0.07,AJo:0.05,ATo:0.03,KQo:0.04,KJo:0.03,KTo:0.01,QJo:0.02",
      raiseActionLabel: "Raise 10",
      raiseSpec:
        "AKs,AQs,AJs,ATs:0.82,A9s:0.84,A8s:0.85,A7s:0.88,A6s:0.15,A5s:0.97,A4s:0.93,A3s:0.31,A2s:0.56,KQs:0.97,KJs:0.91,KTs:0.87,K9s:0.89,K8s:0.23,QJs:0.95,QTs:0.88,Q9s:0.34,JTs:0.94,J9s:0.08,T9s:0.21,98s:0.08,87s:0.05,76s:0.12,65s:0.21,54s:0.10,AA,KK,QQ,JJ,TT:0.94,99:0.88,88:0.85,77:0.82,66:0.55,55:0.13,AKo,AQo:0.93,AJo:0.95,ATo:0.68,KQo:0.96,KJo:0.83,KTo:0.18,QJo:0.12",
    },
    bb: {
      callSpec:
        "ATs:0.79,A9s-A7s,A6s:0.83,A5s:0.26,A4s:0.48,A3s,A2s:0.90,KJs:0.42,KTs:0.65,K9s:0.71,K8s:0.94,K7s:0.85,K6s:0.76,K5s:0.83,K4s:0.85,K3s:0.63,K2s:0.75,QJs:0.18,QTs:0.55,Q9s:0.65,Q8s:0.79,Q7s:0.88,Q6s:0.83,Q5s:0.81,Q4s:0.88,Q3s:0.82,Q2s:0.83,JTs:0.32,J9s:0.29,J8s:0.67,J7s:0.24,J6s:0.61,J5s:0.54,J4s:0.81,J3s:0.18,J2s:0.09,T9s:0.22,T8s:0.39,T7s:0.52,T6s:0.61,T5s:0.13,98s:0.60,97s:0.84,96s:0.83,95s:0.07,87s:0.53,86s:0.86,85s,76s:0.59,75s,74s,65s:0.58,64s,63s:0.72,54s:0.53,53s,52s:0.77,43s:0.98,42s:0.39,99:0.41,88:0.72,77:0.78,66:0.88,55:0.92,44-22,AJo:0.71,ATo:0.69,A9o:0.72,A8o:0.72,A7o:0.52,A6o:0.10,A5o:0.65,A4o:0.24,KQo:0.60,KJo:0.59,KTo:0.55,K9o:0.63,QJo:0.79,QTo:0.76,Q9o:0.43,JTo:0.70,J9o:0.54,T9o:0.64,T8o:0.22,98o:0.15,87o:0.12,76o:0.07",
      raiseActionLabel: "Raise 10",
      raiseSpec:
        "AKs,AQs,AJs,ATs:0.21,A6s:0.17,A5s:0.74,A4s:0.52,A2s:0.10,KQs,KJs:0.58,KTs:0.35,K9s:0.29,K8s:0.06,K7s:0.15,K6s:0.24,K5s:0.17,K4s:0.15,K3s:0.37,K2s:0.25,QJs:0.82,QTs:0.45,Q9s:0.35,Q8s:0.21,Q7s:0.12,Q6s:0.17,Q5s:0.19,Q4s:0.12,Q3s:0.18,Q2s:0.17,JTs:0.68,J9s:0.71,J8s:0.33,J7s:0.76,J6s:0.39,J5s:0.46,J4s:0.11,T9s:0.78,T8s:0.61,T7s:0.48,T6s:0.39,98s:0.40,97s:0.16,96s:0.17,87s:0.47,86s:0.14,76s:0.41,65s:0.42,54s:0.47,43s:0.02,AA,KK,QQ,JJ,TT,99:0.59,88:0.28,77:0.22,66:0.12,55:0.08,AKo,AQo,AJo:0.29,ATo:0.31,A9o:0.28,A8o:0.28,A7o:0.48,A5o:0.35,KQo:0.40,KJo:0.41,KTo:0.45,K9o:0.37,QJo:0.21,QTo:0.24,Q9o:0.05,JTo:0.30,J9o:0.10,T9o:0.19",
    },
  },
  sb: {
    bb: {
      callSpec:
        "ATs:0.66,A9s-A6s,A4s:0.32,A3s:0.84,A2s:0.93,KJs:0.21,KTs:0.74,K9s:0.52,K8s:0.91,K7s,K6s:0.81,K5s:0.88,K4s:0.95,K3s:0.80,K2s:0.84,QJs:0.28,QTs:0.65,Q9s-Q5s,Q4s:0.93,Q3s:0.82,Q2s,JTs:0.51,J9s:0.78,J8s,J7s:0.79,J6s,J5s:0.86,J4s:0.63,J3s:0.89,J2s:0.59,T9s:0.45,T8s:0.76,T7s:0.88,T6s,T5s:0.46,T4s:0.54,T3s:0.30,T2s:0.23,98s:0.28,97s:0.87,96s,95s,87s:0.35,86s,85s,76s:0.20,75s,74s,73s:0.92,65s:0.41,64s,63s,54s:0.37,53s:0.83,52s,43s:0.92,42s,32s:0.82,99:0.21,88:0.71,77:0.77,66:0.85,55:0.14,44-22,AJo:0.72,ATo-A8o,A7o:0.54,A6o:0.6,A5o:0.81,A4o:0.78,A3o:0.42,A2o:0.29,KQo:0.72,KJo:0.90,KTo:0.88,K9o:0.78,K8o:0.22,K7o:0.25,K6o:0.09,QJo,QTo:0.92,Q9o:0.56,Q8o:0.36,JTo:0.96,J9o:0.58,J8o:0.23,T9o:0.87,T8o:0.51,98o:0.86,87o:0.62,76o:0.49,65o:0.38,54o:0.15",
      raiseActionLabel: "Raise 10",
      raiseSpec:
        "AKs,AQs,AJs,ATs:0.34,A5s-A2s,KQs,KJs:0.79,KTs:0.26,K9s:0.48,K8s:0.09,K6s:0.19,K5s:0.12,K4s:0.05,K3s:0.20,K2s:0.16,QJs:0.72,QTs:0.35,Q4s:0.07,Q3s:0.18,JTs:0.49,J9s:0.22,J7s:0.21,J5s:0.14,J4s:0.37,J3s:0.11,J2s:0.41,T9s:0.55,T8s:0.24,T7s:0.12,T5s:0.54,T4s:0.46,T3s:0.42,98s:0.72,97s:0.13,87s:0.65,76s:0.80,65s:0.59,54s:0.63,53s:0.17,43s:0.08,32s:0.18,AA,KK,QQ,JJ,TT,99:0.79,88:0.29,77:0.23,66:0.15,55:0.86,AKo,AQo,AJo:0.28,A7o:0.46,A6o:0.4,A5o:0.19,A4o:0.22,A3o:0.58,A2o:0.71,KQo:0.28,KJo:0.10,KTo:0.12,K9o:0.22,K8o:0.55,K7o:0.48,K6o:0.25,QTo:0.08,Q9o:0.44,Q8o:0.31,JTo:0.04,J9o:0.42,J8o:0.28,T9o:0.13,T8o:0.41",
    },
  },
};

VS_OPEN.hj = {
  co: VS_OPEN.lj.co,
  btn: VS_OPEN.lj.btn,
  sb: VS_OPEN.lj.sb,
  bb: VS_OPEN.lj.bb,
};

const VS_3BET = {
  lj: {
    hj: {
      callSpec:
        "AQs,AJs:0.19,ATs:0.21,A5s:0.05,KQs:0.22,QJs:0.03,JTs:0.13,T9s:0.12,87s:0.11,76s:0.26,65s:0.35,54s:0.32,JJ:0.83,TT:0.28,99:0.28,88:0.36,77:0.29,66:0.24,55:0.32,44:0.15,33:0.10,AKo:0.18,AQo:0.15",
      raiseSpec:
        "AKs,AJs:0.52,ATs:0.23,A9s:0.04,A8s:0.06,A7s:0.22,A5s:0.36,A4s:0.14,KQs:0.28,KJs:0.70,KTs:0.55,K9s:0.22,K8s:0.03,K7s:0.09,K6s:0.20,AA,KK,QQ,JJ:0.17,TT:0.04,AKo:0.82,AQo:0.24",
    },
    co: {
      callSpec:
        "AQs,AJs:0.31,ATs:0.22,A5s:0.10,KQs:0.29,QJs:0.08,JTs:0.16,T9s:0.14,87s:0.14,76s:0.29,65s:0.39,54s:0.38,JJ:0.78,TT:0.31,99:0.32,88:0.36,77:0.32,66:0.24,55:0.34,44:0.16,33:0.11,AKo:0.16,AQo:0.15",
      raiseSpec:
        "AKs,AJs:0.69,ATs:0.26,A9s:0.06,A8s:0.09,A7s:0.23,A5s:0.42,A4s:0.18,KQs:0.37,KJs:0.84,KTs:0.57,K9s:0.34,K8s:0.04,K7s:0.13,K6s:0.22,AA,KK,QQ,JJ:0.22,TT:0.08,AKo:0.84,AQo:0.47",
    },
    btn: {
      callSpec:
        "AQs,AJs:0.35,ATs:0.24,A9s:0.03,A5s:0.14,A4s:0.02,KQs:0.38,KJs:0.03,KTs:0.02,QJs:0.03,QTs:0.02,JTs:0.19,T9s:0.06,98s:0.05,87s:0.02,76s:0.05,65s:0.24,54s:0.22,JJ:0.79,TT:0.36,99:0.29,88:0.28,77:0.45,66:0.28,55:0.12,44:0.06,33:0.02,22:0.02,AKo:0.28,AQo:0.23",
      raiseSpec:
        "AKs,AJs:0.65,ATs:0.03,A9s:0.10,A8s:0.28,A7s:0.25,A6s:0.08,A5s:0.22,A4s:0.34,A3s:0.11,KQs:0.55,KJs:0.97,KTs:0.98,K9s:0.21,K8s:0.06,K7s:0.14,K6s:0.15,K5s:0.05,AA,KK,QQ,JJ:0.21,TT:0.03,AKo:0.72,AQo:0.42",
    },
    sb: {
      callSpec:
        "AKs:0.13,AQs,AJs:0.33,ATs:0.30,A5s:0.22,KQs:0.26,KJs:0.14,QJs:0.05,JTs:0.28,T9s:0.27,87s:0.07,76s:0.09,65s:0.21,54s:0.18,AA:0.06,QQ:0.76,JJ:0.92,TT:0.42,99:0.23,88:0.18,77:0.14,66:0.48,55:0.45,44:0.46,33:0.05,AKo:0.45,AQo:0.02",
      raiseSpec:
        "AKs:0.87,AJs:0.02,ATs:0.04,A9s:0.08,A8s:0.16,A7s:0.14,A6s:0.08,A5s:0.18,A4s:0.17,A3s:0.25,A2s:0.16,KJs:0.72,KTs:0.46,K9s:0.17,K8s:0.15,K7s:0.18,K6s:0.33,K5s:0.02,AA:0.94,KK,QQ:0.24,JJ:0.08,AKo:0.55,AQo:0.16",
    },
    bb: {
      callSpec:
        "AKs:0.27,AQs,AJs,ATs:0.60,A9s:0.10,A8s:0.02,A5s:0.23,A4s:0.01,KQs:0.68,KJs:0.20,KTs:0.08,QJs:0.09,QTs:0.05,JTs:0.08,T9s:0.15,98s:0.02,87s:0.55,76s:0.82,65s:0.80,54s:0.51,AA:0.08,KK:0.02,QQ:0.89,JJ:0.95,TT:0.66,99:0.45,88:0.52,77:0.41,66:0.48,55:0.26,44:0.15,33:0.08,22:0.05,AKo:0.55,AQo:0.08",
      raiseSpec:
        "AKs:0.73,A9s:0.01,A7s:0.12,A6s:0.12,A5s:0.02,A3s:0.05,A2s:0.08,KJs:0.02,KTs:0.04,K9s:0.06,K6s:0.14,AA:0.92,KK:0.98,QQ:0.11,JJ:0.05,AKo:0.65,AQo:0.12",
    },
  },
  hj: {
    co: {
      callSpec:
    "AQs,AJs:0.35,ATs:0.23,A5s:0.07,KQs:0.42,QJs:0.14,JTs:0.17,T9s:0.16,87s:0.44,76s:0.51,65s:0.60,54s:0.47,JJ:0.74,TT:0.65,99:0.39,88:0.37,77:0.32,66:0.24,55:0.35,44,33,AKo:0.15,AQo:0.11",
      raiseSpec:
    "AKs,AJs:0.65,ATs:0.28,A9s:0.02,A8s:0.29,A7s:0.18,A5s:0.49,A4s:0.05,KQs:0.58,KJs,KTs:0.62,K9s:0.37,K8s:0.02,K7s:0.16,K6s:0.26,AA,KK,QQ,JJ:0.26,TT:0.09,AKo:0.85,AQo:0.74",
    },
    btn: {
      callSpec:
    "AQs,AJs:0.71,ATs:0.51,A9s:0.04,A5s:0.15,A4s:0.05,KQs:0.69,KJs:0.19,KTs:0.32,QJs:0.25,QTs:0.16,JTs:0.22,T9s:0.18,98s:0.28,87s:0.46,76s:0.58,65s:0.67,54s:0.54,JJ:0.68,TT:0.83,99:0.78,88:0.63,77:0.51,66:0.32,55:0.16,44,33,22:0.38,AKo:0.21,AQo:0.31",
      raiseSpec:
    "AKs,AJs:0.29,ATs:0.49,A9s:0.14,A8s:0.48,A7s:0.26,A6s:0.09,A5s:0.10,A4s:0.05,A3s:0.02,KQs:0.31,KJs:0.81,KTs:0.68,K9s:0.56,K8s:0.22,K7s:0.16,K6s:0.23,K5s:0.02,AA,KK,QQ,JJ:0.32,TT:0.11,AKo:0.79,AQo:0.55",
    },
    sb: {
      callSpec:
    "AKs:0.08,AQs,AJs:0.98,ATs:0.46,A5s:0.20,KQs:0.82,KJs:0.14,QJs:0.09,JTs:0.33,T9s:0.29,87s:0.14,76s:0.74,65s:0.72,54s:0.53,AA:0.06,QQ:0.32,JJ:0.88,TT:0.61,99:0.42,88:0.24,77:0.16,66:0.14,55:0.21,44:0.18,33:0.39,AKo:0.39,AQo:0.11",
      raiseSpec:
    "AKs:0.92,AJs:0.02,ATs:0.08,A9s:0.28,A8s:0.51,A7s:0.29,A6s:0.22,A5s:0.23,A4s:0.02,A3s:0.27,A2s:0.15,KJs:0.86,KTs:0.48,K9s:0.19,K8s:0.16,K7s:0.18,K6s:0.38,K5s:0.09,AA:0.94,KK,QQ:0.68,JJ:0.12,AKo:0.61,AQo:0.18",
    },
    bb: {
      callSpec:
    "AKs:0.43,AQs,AJs,ATs:0.67,A9s:0.21,A8s:0.13,A5s:0.51,A4s:0.07,KQs,KJs:0.58,KTs:0.23,QJs:0.29,QTs:0.09,JTs:0.08,T9s:0.18,98s:0.02,87s:0.57,76s:0.87,65s:0.84,54s:0.56,AA:0.13,KK:0.16,QQ:0.74,JJ:0.93,TT,99:0.80,88:0.72,77:0.52,66:0.48,55:0.26,44:0.21,33:0.48,22:0.26,AKo:0.29,AQo:0.17",
      raiseSpec:
    "AKs:0.57,A9s:0.01,A7s:0.16,A6s:0.17,A5s:0.05,A3s:0.07,A2s:0.10,KJs:0.42,KTs:0.77,K9s:0.11,K6s:0.08,AA:0.87,KK:0.84,QQ:0.26,JJ:0.07,AKo:0.71,AQo:0.19",
    },
  },
  co: {
    btn: {
      callSpec:
    "AQs,AJs,ATs:0.41,A9s:0.34,A5s:0.33,A4s:0.26,A3s:0.11,KQs,KJs:0.52,KTs:0.32,K9s:0.08,QJs:0.34,QTs:0.46,JTs:0.38,J9s:0.06,T9s:0.36,T8s:0.21,98s:0.17,97s:0.28,87s:0.67,86s:0.41,76s:0.86,65s:0.89,54s:0.96,TT:0.48,99:0.85,88:0.81,77:0.69,66:0.62,55:0.55,44:0.79,33,22,AQo:0.23",
      raiseSpec:
    "AKs,ATs:0.59,A9s:0.02,A8s:0.03,A7s:0.18,A6s:0.08,A5s:0.67,A4s:0.04,KJs:0.48,KTs:0.68,K9s:0.19,JTs:0.12,AA,KK,QQ,JJ,TT:0.52,99:0.10,88:0.08,AKo,AQo:0.77,AJo:0.22,KQo:0.29,KJo:0.13",
    },
    sb: {
      callSpec:
    "AKs:0.08,AQs,AJs,ATs:0.39,A5s:0.28,A4s:0.18,KQs,KJs,KTs:0.62,QJs:0.57,QTs:0.42,JTs:0.49,T9s:0.32,98s:0.12,87s:0.35,76s:0.74,65s:0.88,54s:0.97,AA:0.07,QQ:0.09,JJ:0.31,TT:0.65,99:0.68,88:0.48,77:0.36,66:0.33,55:0.17,44:0.31,33:0.42,22:0.38,AKo:0.17,AQo:0.29",
      raiseSpec:
    "AKs:0.92,ATs:0.41,A9s:0.54,A8s:0.63,A7s:0.52,A6s:0.34,A5s:0.18,A4s:0.04,KTs:0.38,K9s:0.42,K8s:0.17,K7s:0.11,K6s:0.14,K5s:0.12,AA:0.93,KK,QQ:0.91,JJ:0.69,TT:0.35,AKo:0.83,AQo:0.36,AJo:0.07,KQo:0.23",
    },
    bb: {
      callSpec:
    "AKs:0.15,AQs,AJs,ATs:0.72,A9s:0.31,A8s:0.17,A7s:0.08,A5s:0.63,A4s:0.59,A3s:0.21,KQs,KJs,KTs:0.81,K9s:0.11,K6s:0.08,QJs,QTs:0.52,JTs:0.64,T9s:0.22,98s:0.12,87s:0.42,76s:0.72,65s:0.58,54s:0.62,AA:0.09,QQ:0.26,JJ:0.70,TT:0.91,99:0.81,88:0.76,77:0.56,66:0.51,55:0.28,44:0.22,33:0.31,22:0.26,AKo:0.23,AQo:0.44,KQo:0.12",
      raiseSpec:
    "AKs:0.85,ATs:0.28,A9s:0.11,A8s:0.23,A7s:0.27,A6s:0.06,A5s:0.37,A4s:0.41,A3s:0.17,A2s:0.08,KTs:0.19,K9s:0.35,K7s:0.09,K6s:0.05,K4s:0.12,AA:0.91,KK,QQ:0.74,JJ:0.30,AKo:0.77,AQo:0.56,AJo:0.04,KJo:0.17",
    },
  },
  btn: {
    sb: {
      callSpec:
    "AKs:0.12,AQs:0.81,AJs,ATs,A9s:0.81,A8s:0.73,A7s:0.23,A5s:0.76,A4s:0.56,A3s:0.29,KQs,KJs,KTs,K9s:0.72,QJs:0.91,QTs:0.83,Q9s:0.33,JTs:0.93,J9s:0.62,T9s:0.70,T8s:0.23,98s:0.59,87s:0.56,76s:0.65,65s:0.19,54s:0.57,AA:0.18,QQ:0.05,JJ:0.22,TT:0.62,99:0.82,88:0.92,77:0.93,66:0.58,55:0.38,44:0.27,33:0.24,22:0.23,AKo:0.07,AQo:0.61,AJo:0.32,KQo:0.40",
      raiseSpec:
    "AKs:0.88,AQs:0.19,A9s:0.19,A8s:0.27,A7s:0.22,A6s:0.08,A5s:0.24,A4s:0.44,A3s:0.29,K9s:0.19,QJs:0.09,QTs:0.17,Q9s:0.31,JTs:0.07,J9s:0.17,T9s:0.30,T8s:0.11,98s:0.12,87s:0.05,65s:0.16,54s:0.17,AA:0.82,KK,QQ:0.95,JJ:0.78,TT:0.38,99:0.18,88:0.05,AKo:0.93,AQo:0.39,AJo:0.68,ATo:0.04,KQo:0.60,KJo:0.09,KTo:0.03",
    },
    bb: {
      callSpec:
    "AKs:0.21,AQs:0.78,AJs,ATs,A9s,A8s:0.81,A7s:0.41,A5s,A4s:0.72,A3s:0.52,KQs,KJs,KTs,K9s:0.89,K8s:0.13,K6s:0.28,QJs,QTs,Q9s:0.64,JTs,J9s:0.83,T9s,T8s:0.54,98s:0.23,87s:0.64,76s:0.54,65s:0.31,54s:0.43,AA:0.41,QQ:0.04,JJ:0.28,TT:0.69,99,88,77:0.94,66:0.80,55:0.52,44:0.27,33:0.16,22:0.10,AQo:0.75,AJo:0.62,KQo:0.74,KJo:0.28",
      raiseSpec:
    "AKs:0.79,AQs:0.22,A8s:0.19,A7s:0.36,A6s:0.48,A4s:0.14,A3s:0.24,A2s:0.02,K9s:0.11,K8s:0.12,K7s:0.09,K6s:0.02,K5s:0.06,Q9s:0.24,T8s:0.18,98s:0.21,87s:0.05,AA:0.59,KK,QQ:0.96,JJ:0.72,TT:0.31,55:0.13,AKo,AQo:0.25,AJo:0.30,ATo:0.14,KQo:0.26,KJo:0.08,KTo:0.03",
    },
  },
  sb: {
    bb: {
      callSpec:
    "AJs-A7s,A6s:0.41,A5s:0.77,A4s:0.37,A3s:0.25,A2s:0.15,KQs,KJs,KTs,K9s:0.98,K8s:0.92,QJs,QTs,Q9s:0.49,Q8s:0.04,JTs,J9s:0.82,J8s:0.09,T9s:0.81,T8s:0.52,98s:0.26,87s:0.29,76s:0.33,65s:0.29,54s:0.21,TT:0.13,99:0.67,88,77,66,55:0.64,44:0.45,33:0.29,22:0.12,AQo:0.11,AJo:0.23,ATo:0.09,KQo:0.26,KJo:0.22,QJo:0.06",
      raiseSpec:
        "AKs,AQs,A6s:0.59,A5s:0.23,A4s:0.63,A3s:0.75,A2s:0.41,K9s:0.02,K8s:0.08,Q9s:0.51,Q8s:0.06,J9s:0.18,T9s:0.19,T8s:0.31,AA,KK,QQ,JJ,TT:0.87,99:0.33,55:0.22,AKo,AQo:0.89,AJo:0.77,ATo:0.91,KQo:0.74,KJo:0.42,KTo:0.14,QJo:0.21,QTo:0.11,JTo:0.08",
    },
  },
};

const VS_OPEN_CALL = {
  lj: {
    btn: {
      sb: {
        callSpec:
          "AQs:0.22,AJs:0.68,ATs,A9s:0.81,A8s:0.46,A5s:0.66,A4s:0.64,A3s:0.19,KTs:0.35,QJs:0.52,QTs,JTs:0.73,J9s:0.22,T9s:0.83,98s:0.06,76s:0.35,65s:0.42,54s:0.37,JJ:0.22,TT,99,88,77,66,55,44,33,22,KQo:0.18",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs,AQs:0.78,AJs:0.32,A8s:0.31,A5s:0.34,A4s:0.36,KQs,KJs,KTs:0.65,K9s:0.84,K8s:0.08,K7s:0.07,QJs:0.48,JTs:0.27,J9s:0.12,76s:0.25,65s:0.05,AA,KK,QQ,JJ:0.78,AKo,AQo,KQo:0.63",
      },
      bb: {
        callSpec:
          "AQs:0.79,AJs:1,ATs:1,A9s:1,A8s:1,A7s:1,A6s:1,A5s:0.85,A4s:1,A3s:0.95,A2s:1,KQs:0.12,KTs:0.78,K9s:0.66,K8s:0.58,K7s:0.62,K6s:0.42,K5s:0.69,K4s:1,K3s:0.77,K2s:0.97,QJs:0.59,QTs:1,Q9s:1,Q8s:0.72,JTs:1,J9s:1,J8s:1,T9s:1,T8s:1,T7s:0.88,98s:1,97s:1,96s:1,87s:1,86s:1,76s:1,75s:1,65s:1,64s:1,63s:0.94,54s:1,53s:1,52s:0.98,43s:1,42s:0.48,JJ:0.33,TT:1,99:1,88:1,77:1,66:1,55:1,44:1,33:1,22:1,AJo:0.87,ATo:0.58,KQo:0.43,KJo:0.67,KTo:0.5,QJo:0.85,QTo:0.36,JTo:1,T9o:0.18,54o:0.05",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs:1,AQs:0.21,A5s:0.15,A3s:0.06,KQs:0.89,KJs:1,KTs:0.23,K9s:0.34,K8s:0.42,K7s:0.39,K6s:0.59,K5s:0.31,QJs:0.41,AA:1,KK:1,QQ:1,JJ:0.67,AKo:1,AQo:1,AJo:0.13,KQo:0.57,KJo:0.33",
      },
    },
    sb: {
      bb: {
        callSpec:
          "AQs:0.7,AJs:1,ATs:1,A9s:1,A8s:1,A7s:0.8,A6s:1,A5s:0.79,A4s:0.87,A3s:0.94,A2s:0.86,KTs:0.46,K9s:0.98,K8s:0.17,K7s:0.47,K6s:0.42,K5s:0.69,K4s:0.63,K3s:0.72,K2s:1,QJs:0.72,QTs:1,Q9s:1,Q8s:0.99,Q6s:0.66,JTs:0.98,J9s:1,J8s:1,J7s:0.35,T9s:1,T8s:1,T7s:0.88,98s:1,97s:1,96s:1,87s:1,86s:1,85s:0.95,76s:1,75s:1,74s:0.3,65s:1,64s:1,63s:1,54s:1,53s:1,52s:0.94,43s:1,42s:0.38,JJ:0.19,TT:1,99:1,88:1,77:1,66:1,55:1,44:1,33:1,22:1,AQo:0.09,AJo:0.49,ATo:0.61,KQo:0.79,KJo:0.52,KTo:0.82,QJo:1,QTo:0.58,JTo:1,76o:0.28,65o:0.17,54o:0.39",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs:1,AQs:0.3,A7s:0.2,A5s:0.21,A4s:0.13,A3s:0.06,A2s:0.14,KQs:1,KJs:1,KTs:0.54,K9s:0.02,K8s:0.83,K7s:0.53,K6s:0.59,K5s:0.31,K4s:0.37,K3s:0.29,QJs:0.29,JTs:0.02,AA:1,KK:1,QQ:1,JJ:0.81,AKo:1,AQo:0.92,AJo:0.51,KQo:0.22,KJo:0.49",
      },
    },
  },
  hj: {
    btn: {
      sb: {
        callSpec:
          "AQs:0.03,AJs:0.41,ATs:1,A9s:1,A8s:0.82,A7s:0.31,A6s:0.56,A5s:0.71,A4s:0.76,A3s:0.31,KQs:0.03,KTs:0.3,QJs:0.69,QTs:1,JTs:0.43,J9s:0.23,T9s:1,98s:0.19,76s:0.33,65s:0.42,54s:0.56,TT:0.89,99:0.96,88:1,77:1,66:1,55:1,44:1,33:1,22:1,AJo:0.03,KQo:0.35",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs:1,AQs:0.98,AJs:0.6,A8s:0.18,A7s:0.16,A6s:0.03,A5s:0.3,A4s:0.25,KQs:0.98,KJs:1,KTs:0.71,K9s:0.68,QJs:0.32,JTs:0.58,J9s:0.77,76s:0.16,65s:0.22,AA:1,KK:1,QQ:1,JJ:1,TT:0.11,99:0.04,AKo:1,AQo:1,AJo:0.23,KQo:0.66,KJo:0.08",
      },
    },
    sb: {
      bb: {
        callSpec:
          "AJs:1,ATs:1,A9s:1,A8s:1,A7s:0.9,A6s:1,A5s:0.71,A4s:0.97,A3s:1,A2s:0.71,KJs:0.49,KTs:0.72,K9s:0.38,K8s:0.5,K7s:0.71,K6s:0.3,K5s:0.86,K4s:0.94,K3s:0.64,K2s:0.84,QJs:0.63,QTs:1,Q9s:1,Q8s:0.78,Q7s:0.41,Q6s:0.97,JTs:0.74,J9s:1,J8s:1,J7s:0.6,T9s:0.86,T8s:1,T7s:1,98s:1,97s:1,96s:1,87s:0.94,86s:1,85s:1,76s:0.96,75s:1,74s:0.37,65s:0.86,64s:1,63s:1,54s:0.92,53s:1,52s:1,43s:1,42s:0.76,TT:0.76,99:1,88:1,77:1,66:1,55:1,44:1,33:1,22:1,AQo:0.36,AJo:0.18,ATo:0.76,KQo:0.85,KJo:0.34,KTo:0.84,QJo:1,QTo:1,JTo:0.99,T9o:0.39,98o:0.18,76o:0.37,65o:0.31,54o:0.63",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs:1,AQs:1,A7s:0.11,A5s:0.3,A4s:0.04,A2s:0.3,KQs:1,KJs:0.51,KTs:0.29,K9s:0.62,K8s:0.51,K7s:0.3,K6s:0.71,K5s:0.14,K4s:0.07,K3s:0.37,QJs:0.38,Q8s:0.23,JTs:0.26,J7s:0.41,T9s:0.14,87s:0.07,76s:0.04,65s:0.14,54s:0.09,AA:1,KK:1,QQ:1,JJ:1,TT:0.25,AKo:1,AQo:0.65,AJo:0.82,ATo:0.25,KQo:0.15,KJo:0.66,KTo:0.17,JTo:0.02",
      },
    },
  },
  co: {
    btn: {
      sb: {
        callSpec:
          "AQs:0.07,AJs:0.41,ATs:0.64,A9s:1,A8s:0.92,A7s:0.41,A6s:0.43,A5s:0.99,A4s:0.82,A3s:0.31,KQs:0.03,K9s:0.48,QJs:0.82,QTs:0.79,JTs:0.15,J9s:0.27,T9s:0.5,T8s:0.04,98s:0.46,76s:0.27,65s:0.43,54s:0.36,TT:0.03,99:0.89,88:0.98,77:1,66:1,55:1,44:1,33:1,22:1,AJo:0.19,KQo:0.33",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs:1,AQs:0.94,AJs:0.6,ATs:0.36,A8s:0.09,A7s:0.19,A6s:0.19,A5s:0.02,A4s:0.1,KQs:0.97,KJs:1,KTs:1,K9s:0.37,QJs:0.18,QTs:0.21,JTs:0.85,J9s:0.74,T9s:0.5,76s:0.07,65s:0.09,AA:1,KK:1,QQ:1,JJ:1,TT:0.97,99:0.12,88:0.03,AKo:1,AQo:1,AJo:0.81,KQo:0.67,KJo:0.57",
      },
      bb: {
        callSpec:
          "AJs:0.98,ATs:1,A9s:1,A8s:1,A7s:0.85,A6s:1,A5s:0.94,A4s:1,A3s:0.99,A2s:1,KQs:0.44,KTs:0.03,K9s:1,K8s:1,K7s:1,K6s:0.63,K5s:1,K4s:1,K3s:1,K2s:1,QJs:1,QTs:0.47,Q9s:1,Q8s:0.85,Q7s:1,Q6s:1,Q5s:0.32,JTs:0.07,J9s:0.65,J8s:0.72,J7s:0.51,T9s:0.97,T8s:1,T7s:0.73,98s:1,97s:1,96s:1,87s:0.99,86s:1,85s:1,76s:1,75s:1,74s:0.69,65s:0.93,64s:1,63s:1,54s:1,53s:1,52s:1,43s:1,42s:0.74,TT:0.16,99:1,88:1,77:1,66:1,55:1,44:1,33:1,22:1,AJo:0.18,ATo:0.9,KQo:0.45,KJo:0.47,KTo:0.76,QJo:1,QTo:1,JTo:0.86,T9o:0.59,98o:0.36,76o:0.13,65o:0.15,54o:0.29",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs:1,AQs:1,AJs:0.03,A7s:0.15,A5s:0.06,A3s:0.01,KQs:0.57,KJs:1,KTs:0.98,K6s:0.38,QTs:0.53,Q8s:0.16,JTs:0.94,J9s:0.35,J8s:0.29,J7s:0.49,T9s:0.03,T7s:0.28,87s:0.01,65s:0.08,AA:1,KK:1,QQ:1,JJ:1,TT:0.85,AKo:1,AQo:1,AJo:0.82,ATo:0.1,KQo:0.56,KJo:0.54,KTo:0.24,JTo:0.14",
      },
    },
    sb: {
      bb: {
        callSpec:
          "AJs:0.68,ATs:1,A9s:1,A8s:1,A7s:1,A6s:1,A5s:1,A4s:1,A3s:1,A2s:1,KQs:0.32,KTs:0.32,K9s:1,K8s:1,K7s:1,K6s:1,K5s:1,K4s:1,K3s:1,K2s:1,QJs:1,QTs:1,Q9s:1,Q8s:0.85,Q7s:0.76,Q6s:0.2,Q5s:1,Q4s:0.47,Q3s:1,Q2s:1,JTs:0.35,J9s:1,J8s:1,J7s:0.91,J6s:1,J5s:1,J4s:0.7,T9s:0.94,T8s:0.75,T7s:0.99,98s:1,97s:1,96s:1,87s:1,86s:1,85s:1,76s:1,75s:1,74s:1,65s:1,64s:1,63s:1,54s:1,53s:1,52s:1,43s:1,42s:1,32s:0.98,88:1,77:1,66:1,55:1,44:1,33:1,22:1,AJo:0.54,ATo:0.14,A9o:0.92,A8o:0.66,A7o:0.62,A6o:0.29,A5o:0.23,KQo:0.71,KJo:1,KTo:0.77,K9o:0.54,QJo:0.78,QTo:0.74,Q9o:0.46,JTo:1,J9o:0.92,T9o:0.82,T8o:0.93,98o:0.9,87o:1,86o:0.46,76o:1,65o:1,54o:1,53o:0.14",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs:1,AQs:1,AJs:0.32,KQs:0.68,KJs:1,KTs:0.68,Q8s:0.16,Q7s:0.25,Q6s:0.8,Q4s:0.54,JTs:0.65,J7s:0.09,T9s:0.07,T8s:0.26,T7s:0.02,T6s:1,T5s:0.65,AA:1,KK:1,QQ:1,JJ:1,TT:1,99:1,AKo:1,AQo:1,AJo:0.47,ATo:0.86,A9o:0.08,A8o:0.35,A7o:0.39,A5o:0.78,A4o:0.19,KQo:0.29,KTo:0.24,K9o:0.47,QJo:0.22,QTo:0.26,Q9o:0.55,J9o:0.09,T9o:0.19,T8o:0.08,98o:0.1",
      },
    },
  },
  btn: {
    sb: {
      bb: {
        callSpec:
          "AJs:0.68,ATs:1,A9s:1,A8s:1,A7s:1,A6s:1,A5s:1,A4s:1,A3s:1,A2s:1,KQs:0.32,KTs:0.32,K9s:1,K8s:1,K7s:1,K6s:1,K5s:1,K4s:1,K3s:1,K2s:1,QJs:1,QTs:1,Q9s:1,Q8s:0.85,Q7s:0.76,Q6s:0.2,Q5s:1,Q4s:0.47,Q3s:1,Q2s:1,JTs:0.35,J9s:1,J8s:1,J7s:0.91,J6s:1,J5s:1,J4s:0.7,T9s:0.94,T8s:0.75,T7s:0.99,98s:1,97s:1,96s:1,87s:1,86s:1,85s:1,76s:1,75s:1,74s:1,65s:1,64s:1,63s:1,54s:1,53s:1,52s:1,43s:1,42s:1,32s:0.98,88:1,77:1,66:1,55:1,44:1,33:1,22:1,AJo:0.54,ATo:0.14,A9o:0.92,A8o:0.66,A7o:0.62,A6o:0.29,A5o:0.23,KQo:0.71,KJo:1,KTo:0.77,K9o:0.54,QJo:0.78,QTo:0.74,Q9o:0.46,JTo:1,J9o:0.92,T9o:0.82,T8o:0.93,98o:0.9,87o:1,86o:0.46,76o:1,65o:1,54o:1,53o:0.14",
        raiseActionLabel: "Raise 10",
        raiseSpec:
          "AKs:1,AQs:1,AJs:0.32,KQs:0.68,KJs:1,KTs:0.68,Q8s:0.16,Q7s:0.25,Q6s:0.8,Q4s:0.54,JTs:0.65,J7s:0.09,T9s:0.07,T8s:0.26,T7s:0.02,T6s:1,T5s:0.65,AA:1,KK:1,QQ:1,JJ:1,TT:1,99:1,AKo:1,AQo:1,AJo:0.47,ATo:0.86,A9o:0.08,A8o:0.35,A7o:0.39,A5o:0.78,A4o:0.19,KQo:0.29,KTo:0.24,K9o:0.47,QJo:0.22,QTo:0.26,Q9o:0.55,J9o:0.09,T9o:0.19,T8o:0.08,98o:0.1",
      },
    },
  },
};

const VS_4BET = {
  lj: {
    hj: {
      // HIAllinLOcall -> COAllinHIcall mapping family.
      callSpec:
        "AQs:0.97,AJs:0.65,ATs:0.61,A5s:0.49,A4s:0.01,KQs:0.55,KJs:0.2,KTs:0.12,AA:0.83,QQ:0.93,JJ:0.81,TT:0.52,99:0.39,88:0.3,77:0.33,66:0.46,AKo:0.54,AQo:0.14",
      raiseSpec: "AKs:1,AA:1,KK:1,QQ:0.93,JJ:1,TT:0.6,AKo:1",
    },
    co: {
      // COAllinLOcall -> COAllinHIcall mapping family.
      callSpec:
        "AQs:0.97,AJs:0.65,ATs:0.61,A5s:0.49,A4s:0.01,KQs:0.55,KJs:0.2,KTs:0.12,AA:0.83,QQ:0.93,JJ:0.81,TT:0.52,99:0.39,88:0.3,77:0.33,66:0.46,AKo:0.54,AQo:0.14",
      raiseSpec: "AKs:1,AA:1,KK:1,QQ:0.93,JJ:1,TT:0.6,AKo:1",
    },
    btn: {
      // BTNAllinLOcall -> BTNAllinHIcall mapping family.
      callSpec:
        "AKs:0.06,AQs:1,AJs:0.46,ATs:0.57,A5s:0.52,A4s:0.1,KQs:0.51,KJs:0.38,KTs:0.05,AA:0.81,QQ:0.88,JJ:0.66,TT:0.57,99:0.43,88:0.33,77:0.29,66:0.38,55:0.23,AKo:0.43,AQo:0.18",
      raiseSpec: "AKs:0.95,AA:0.2,KK:1,QQ:0.02,AKo:0.48",
    },
    sb: {
      // SBAllinLOcall -> SBAllinHIcall mapping family.
      callSpec:
        "AKs:0.25,AQs:1,AJs:0.41,ATs:0.35,A5s:0.15,KJs:0.29,KTs:0.09,T9s:0.08,65s:0.01,AA:0.33,QQ:0.61,JJ:0.64,TT:0.55,99:0.41,88:0.28,77:0.32,66:0.19,55:0.16,AKo:0.27",
      raiseSpec: "AKs:0.75,A5s:0.75,A2s:0.2,AA:0.67,KK:1,QQ:0.39,JJ:0.21,AKo:0.72",
    },
    bb: {
      // BBAllinLOcall -> BBAllinHIcall mapping family.
      callSpec:
        "AKs:0.19,AQs:1,ATs:0.4,A5s:0.02,KJs:0.94,KTs:0.22,JTs:0.27,T9s:0.54,87s:0.43,76s:0.36,65s:0.43,54s:0.35,AA:0.33,QQ:0.67,JJ:0.63,TT:0.23,99:0.05,AKo:0.26,AQo:0.12",
      raiseSpec: "AKs:0.1,A7s:1,A5s:0.96,A4s:0.71,QTs:0.5,KK:1,QQ:0.9,JJ:0.2,AKo:0.96",
    },
  },
  sb: {
    bb: {
      callSpec:
        "AKs:0.91,AQs:1,AJs:1,ATs:0.54,A5s:0.04,A4s:0.18,A3s:0.14,KQs:1,KJs:1,KTs:0.95,JTs:0.34,T9s:0.42,98s:0.16,87s:0.13,76s:0.39,65s:0.18,54s:0.54,AA:1,QQ:0.1,JJ:0.81,TT:1,99:0.83,88:0.48,77:0.23,66:0.39,55:0.04,AKo:0.04,AQo:1,AJo:0.03,KQo:0.31",
      raiseSpec: "AKs:1,A5s:0.6,A3s:0.04,AA:0.17,KK:1,QQ:0.86,JJ:0.3,TT:0.37,AKo:1",
    },
  },
  btn: {
    bb: {
      callSpec:
        "AQs:1,AJs:1,A5s:0.38,A4s:0.18,KQs:1,KJs:1,KTs:1,K9s:0.07,K6s:0.2,QTs:0.1,JTs:0.69,J9s:0.13,T9s:1,T8s:1,98s:0.85,87s:0.66,76s:1,65s:0.44,54s:0.76,AA:0.84,QQ:0.14,JJ:0.7,TT:0.63,99:0.77,88:0.22,AQo:1,AJo:0.31",
      raiseSpec: "AKs:0.82,A5s:0.93,AA:0.68,KK:1,QQ:0.33,JJ:0.15,AKo:0.75",
    },
    sb: {
      callSpec:
        "AQs:1,AJs:0.83,ATs:0.97,A9s:0.07,A8s:0.34,A4s:0.23,KQs:0.96,KJs:1,KTs:0.93,K9s:0.27,QJs:0.47,QTs:0.53,JTs:0.22,T9s:0.8,98s:0.2,AA:0.49,JJ:0.71,TT:0.54,99:0.82,88:0.74,77:0.58,66:0.47,55:0.37,44:0.25,AQo:0.83,AJo:0.2",
      raiseSpec: "AKs:1,A5s:1,A4s:0.46,AA:0.52,KK:1,QQ:1,JJ:0.29,TT:0.31,AKo:1",
    },
  },
  co: {
    bb: {
      callSpec:
        "AQs:1,AJs:0.46,ATs:0.07,A8s:0.16,A5s:0.34,A4s:0.24,KQs:0.66,KJs:1,KTs:0.64,JTs:0.84,T9s:1,T8s:0.08,98s:0.02,87s:0.54,76s:0.42,65s:0.43,54s:0.38,AA:0.45,QQ:0.49,JJ:0.7,TT:0.74,99:0.18,AKo:0.13,AQo:0.57",
      raiseSpec: "AKs:0.55,AA:0.55,KK:1,QQ:0.51,JJ:0.31,AKo:0.88",
    },
    sb: {
      callSpec:
        "AKs:0.01,AQs:1,AJs:0.99,ATs:0.63,A9s:0.09,A5s:0.26,A4s:0.06,KQs:0.99,KJs:0.41,KTs:0.32,JTs:0.2,T9s:0.23,AA:0.39,QQ:0.43,JJ:0.57,TT:0.82,99:0.67,88:0.5,77:0.41,66:0.31,55:0.29,44:0.11,AKo:0.09,AQo:0.4",
      raiseSpec: "AKs:0.99,A5s:0.57,A2s:0.08,AA:0.62,KK:1,QQ:0.57,JJ:0.39,AKo:0.92",
    },
    btn: {
      callSpec:
        "AKs:0.25,AQs:1,AJs:0.71,ATs:0.64,A9s:0.16,A5s:0.54,A4s:0.12,KQs:0.68,KJs:0.75,KTs:0.23,JTs:0.12,AA:0.95,QQ:0.45,JJ:0.79,TT:0.76,99:0.76,88:0.57,77:0.34,66:0.53,55:0.4,44:0.08,AKo:0.28,AQo:0.67",
      raiseSpec: "AKs:0.75,AA:0.06,KK:1,QQ:0.55,AKo:0.71",
    },
  },
  hj: {
    bb: {
      callSpec:
        "AKs:0.19,AQs:1,ATs:0.4,A5s:0.02,KJs:0.94,KTs:0.22,JTs:0.27,T9s:0.54,87s:0.43,76s:0.36,65s:0.43,54s:0.35,AA:0.33,QQ:0.67,JJ:0.63,TT:0.23,99:0.05,AKo:0.26,AQo:0.12",
      raiseSpec: "AKs:0.1,A7s:1,A5s:0.96,A4s:0.71,QTs:0.5,KK:1,QQ:0.9,JJ:0.2,AKo:0.96",
    },
    sb: {
      callSpec:
        "AKs:0.25,AQs:1,AJs:0.41,ATs:0.35,A5s:0.15,KJs:0.29,KTs:0.09,T9s:0.08,65s:0.01,AA:0.33,QQ:0.61,JJ:0.64,TT:0.55,99:0.41,88:0.28,77:0.32,66:0.19,55:0.16,AKo:0.27",
      raiseSpec: "AKs:0.75,A5s:0.75,A2s:0.2,AA:0.67,KK:1,QQ:0.39,JJ:0.21,AKo:0.72",
    },
    btn: {
      callSpec:
        "AKs:0.06,AQs:1,AJs:0.46,ATs:0.57,A5s:0.52,A4s:0.1,KQs:0.51,KJs:0.38,KTs:0.05,AA:0.81,QQ:0.88,JJ:0.66,TT:0.57,99:0.43,88:0.33,77:0.29,66:0.38,55:0.23,AKo:0.43,AQo:0.18",
      raiseSpec: "AKs:0.95,AA:0.2,KK:1,QQ:0.02,AKo:0.48",
    },
    co: {
      callSpec:
        "AQs:0.97,AJs:0.65,ATs:0.61,A5s:0.49,A4s:0.01,KQs:0.55,KJs:0.2,KTs:0.12,AA:0.83,QQ:0.93,JJ:0.81,TT:0.52,99:0.39,88:0.3,77:0.33,66:0.46,AKo:0.54,AQo:0.14",
      raiseSpec: "AKs:1,AA:1,KK:1,QQ:0.93,JJ:1,TT:0.6,AKo:1",
    },
  },
};

const VS_5BET = {
  lj: {
    hj: {
      // HIAllinLOcall -> COAllinHIcall
      callSpec: "AKs:1,AA:0.17,KK:1,AKo:0.41",
    },
    co: {
      // COAllinLOcall -> COAllinHIcall
      callSpec: "AKs:1,AA:0.17,KK:1,AKo:0.41",
    },
    btn: {
      // BTNAllinLOcall -> BTNAllinHIcall
      callSpec: "AKs:1,AA:1,KK:1,QQ:0.9,JJ:0.91,TT:1,AKo:1",
    },
    sb: {
      // SBAllinLOcall -> SBAllinHIcall
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,AKo:1",
    },
    bb: {
      // BBAllinLOcall -> BBAllinHIcall
      callSpec: "AKs:1,AQs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,99:1,88:1,77:1,66:1,55:1,AKo:1",
    },
  },
  sb: {
    bb: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,99:1,88:1,77:1,66:1,AKo:1",
    },
  },
  btn: {
    bb: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,99:0.93,AKo:1",
    },
    sb: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,99:1,88:1,77:1,AKo:1",
    },
  },
  co: {
    bb: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,AKo:1",
    },
    sb: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,AKo:1",
    },
    btn: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:0.91,TT:1,AKo:1",
    },
  },
  hj: {
    bb: {
      callSpec: "AKs:1,AQs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,99:1,88:1,77:1,66:1,55:1,AKo:1",
    },
    sb: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:1,TT:1,AKo:1",
    },
    btn: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:0.9,JJ:0.91,TT:1,AKo:1",
    },
    co: {
      callSpec: "AKs:1,AA:1,KK:1,QQ:1,JJ:1,TT:0.6,AKo:1",
    },
  },
};

const RANKS_DESC = ["A", "K", "Q", "J", "T", "9", "8", "7", "6", "5", "4", "3", "2"];
const SUITS = ["s", "h", "d", "c"];

function generateAllCombosForHandLabel(label) {
  const combos = [];
  if (!label) return combos;
  if (label.length === 2) {
    const r = label[0];
    for (let i = 0; i < SUITS.length; i++) {
      for (let j = i + 1; j < SUITS.length; j++) combos.push(`${r}${SUITS[i]}${r}${SUITS[j]}`);
    }
    return combos;
  }
  if (label.length === 3 && label[2] === "s") {
    const r1 = label[0], r2 = label[1];
    for (const s of SUITS) combos.push(`${r1}${s}${r2}${s}`);
    return combos;
  }
  if (label.length === 3 && label[2] === "o") {
    const r1 = label[0], r2 = label[1];
    for (let i = 0; i < SUITS.length; i++) {
      for (let j = 0; j < SUITS.length; j++) if (i !== j) combos.push(`${r1}${SUITS[i]}${r2}${SUITS[j]}`);
    }
    return combos;
  }
  return combos;
}

function normalizeSpec(spec) {
  // Tolerate common delimiter typos and expand hyphen ranges (e.g. ATs-A7s, 44-22).
  const s = (spec || "").replace(/;/g, ":");
  const rankOrder = ["A", "K", "Q", "J", "T", "9", "8", "7", "6", "5", "4", "3", "2"];
  const idx = (r) => rankOrder.indexOf(r);
  const expandRangeToken = (token) => {
    if (!token || !token.includes("-")) return [token];
    const mPair = token.match(/^([2-9TJQKA])\1-([2-9TJQKA])\2$/i);
    if (mPair) {
      const hi = mPair[1].toUpperCase();
      const lo = mPair[2].toUpperCase();
      const out = [];
      for (let i = idx(hi); i <= idx(lo); i++) out.push(`${rankOrder[i]}${rankOrder[i]}`);
      return out;
    }
    const m = token.match(/^([2-9TJQKA])([2-9TJQKA])(s|o)-([2-9TJQKA])([2-9TJQKA])(s|o)$/i);
    if (m) {
      const a1 = m[1].toUpperCase();
      const a2 = m[2].toUpperCase();
      const so1 = m[3].toLowerCase();
      const b1 = m[4].toUpperCase();
      const b2 = m[5].toUpperCase();
      const so2 = m[6].toLowerCase();
      if (so1 !== so2) return [token];
      if (a1 === b1) {
        const out = [];
        for (let i = idx(a2); i <= idx(b2); i++) out.push(`${a1}${rankOrder[i]}${so1}`);
        return out;
      }
    }
    return [token];
  };
  return s
    .split(",")
    .flatMap((t) => expandRangeToken((t || "").trim()))
    .filter(Boolean)
    .join(",");
}

function build13x13ResponseGridFromActionMaps({
  callFreqMap = null,
  raiseFreqMap = null,
  baseFreqMap = null,
  raiseActionLabel = "Raise 7.5",
}) {
  const hasCall = !!callFreqMap;
  const actions = hasCall ? ["Fold", "Call", raiseActionLabel] : ["Fold", raiseActionLabel];
  const grid = Array(13)
    .fill(null)
    .map(() => Array(13).fill(null));

  for (let row = 0; row < 13; row++) {
    for (let col = 0; col < 13; col++) {
      const r1 = RANKS_DESC[row];
      const r2 = RANKS_DESC[col];
      const label = row === col ? `${r1}${r1}` : row < col ? `${r1}${r2}s` : `${r2}${r1}o`;
      const type = row === col ? "pair" : row < col ? "suited" : "offsuit";
      const hasBase = !!baseFreqMap;
      let call = Math.max(0, Math.min(1, Number(callFreqMap?.[label] ?? 0)));
      let raise = Math.max(0, Math.min(1, Number(raiseFreqMap?.[label] ?? 0)));
      let base = 0;
      let fold = 0;
      if (hasBase) {
        // Response nodes should represent "what to do now" from 100% of the
        // brought-through range at this node. Keep pure hardcoded response
        // percentages and compute fold as the remainder.
        const broughtThrough = Math.max(0, Math.min(1, Number(baseFreqMap?.[label] ?? 0)));
        if (broughtThrough > 0) {
          base = 1;
          fold = Math.max(0, 1 - call - raise);
        } else {
          base = 0;
          call = 0;
          raise = 0;
          fold = 0;
        }
      } else {
        // VS_OPEN style responses: show listed response hands as 100% "now".
        const used = Math.max(0, Math.min(1, call + raise));
        if (used > 0) {
          base = 1;
          fold = Math.max(0, 1 - used);
        } else {
          base = 0;
          fold = 0;
        }
      }
      const frequencies = hasCall ? [fold, call, raise] : [fold, raise];
      const combos = generateAllCombosForHandLabel(label).map((comboHand) => ({
        hand: comboHand,
        frequencies,
        ev: 0,
        equity: 0,
      }));
      grid[row][col] = {
        label,
        type,
        inRange: base > 0.001,
        frequency: base,
        frequencies,
        ev: 0,
        equity: 0,
        combos,
      };
    }
  }
  return { actions, grid };
}

function build13x13CallOnlyResponseGridFromActionMap({
  callFreqMap = null,
  baseFreqMap = null,
}) {
  const actions = ["Fold", "Call"];
  const grid = Array(13)
    .fill(null)
    .map(() => Array(13).fill(null));

  for (let row = 0; row < 13; row++) {
    for (let col = 0; col < 13; col++) {
      const r1 = RANKS_DESC[row];
      const r2 = RANKS_DESC[col];
      const label = row === col ? `${r1}${r1}` : row < col ? `${r1}${r2}s` : `${r2}${r1}o`;
      const type = row === col ? "pair" : row < col ? "suited" : "offsuit";

      const base = Math.max(0, Math.min(1, Number(baseFreqMap?.[label] ?? 0)));
      const call = base > 0 ? Math.max(0, Math.min(1, Number(callFreqMap?.[label] ?? 0))) : 0;
      const fold = base > 0 ? Math.max(0, 1 - call) : 0;

      const frequencies = [fold, call];
      const combos = generateAllCombosForHandLabel(label).map((comboHand) => ({
        hand: comboHand,
        frequencies,
        ev: 0,
        equity: 0,
      }));
      grid[row][col] = {
        label,
        type,
        inRange: base > 0.001,
        frequency: base,
        frequencies,
        ev: 0,
        equity: 0,
        combos,
      };
    }
  }
  return { actions, grid };
}

export function getOpenSpecForPosition(posId) {
  return OPENS[posId] || null;
}

export function getOpenGridForPosition(posId) {
  const cfg = getOpenSpecForPosition(posId);
  if (!cfg) {
    return { actions: ["Open"], grid: null, openSizeBb: null };
  }
  const freqMap = parseRangeSpecToFreqMap(cfg.spec);
  const actionLabel = `Open ${cfg.openSizeBb}`;
  const { actions, grid } = build13x13GridFromHandFreqMap(freqMap, actionLabel);
  return { actions, grid, openSizeBb: cfg.openSizeBb };
}

export function getPreflopDecisionGrid(preflopHistory, preflopState) {
  const actingPos = preflopState?.position;
  const history = (preflopHistory || []).filter((a) => a.action !== "fold");
  const actionName = (a) => String(a || "").toLowerCase();
  const isAllInAction = (a) => /all[\s-]?in/.test(actionName(a));

  // Open -> 3bet -> opener response (Call / Raise 22 / Fold).
  if (
    history.length === 2 &&
    actionName(history[0]?.action) === "open" &&
    (actionName(history[1]?.action) === "3bet" || actionName(history[1]?.action) === "raise") &&
    actingPos === history[0]?.position
  ) {
    const opener = history[0]?.position;
    const threeBettor = history[1]?.position;
    const vs3bet = VS_3BET?.[opener]?.[threeBettor] || null;
    const callSpec = vs3bet?.callSpec || null;
    const raiseSpec = vs3bet?.raiseSpec || null;

    let callMap = callSpec ? parseRangeSpecToFreqMap(normalizeSpec(callSpec)) : null;
    let raiseMap = raiseSpec ? parseRangeSpecToFreqMap(normalizeSpec(raiseSpec)) : null;
    const openGrid = getOpenGridForPosition(opener)?.grid || [];
    const baseMap = {};
    for (const row of openGrid) {
      for (const cell of row || []) {
        if (cell?.label) baseMap[cell.label] = Math.max(0, Math.min(1, Number(cell.frequency || 0)));
      }
    }

    // Fallback so opener decision grids always render even without explicit specs.
    if (!callMap && !raiseMap) {
      callMap = {};
      raiseMap = {};
      for (const label of Object.keys(baseMap)) {
        const b = baseMap[label] || 0;
        const r = Math.min(0.35, b * 0.25);
        const c = Math.min(0.75, Math.max(0, b - r));
        raiseMap[label] = r;
        callMap[label] = c;
      }
    }

    const { actions, grid } = build13x13ResponseGridFromActionMaps({
      callFreqMap: callMap,
      raiseFreqMap: raiseMap,
      baseFreqMap: baseMap,
      raiseActionLabel: "Raise 22",
    });
    return { actions, grid, source: `${opener}_open_${threeBettor}_3bet_${opener}` };
  }

  // Open -> 3bet -> 4bet -> 3bettor response (Call / All in / Fold).
  if (
    history.length === 3 &&
    actionName(history[0]?.action) === "open" &&
    (actionName(history[1]?.action) === "3bet" || actionName(history[1]?.action) === "raise") &&
    (actionName(history[2]?.action) === "4bet" || actionName(history[2]?.action) === "raise") &&
    actingPos === history[1]?.position
  ) {
    const opener = history[0]?.position;
    const threeBettor = history[1]?.position;
    const vs4bet = VS_4BET?.[opener]?.[threeBettor] || null;
    const callSpec = vs4bet?.callSpec || null;
    const allinSpec = vs4bet?.raiseSpec || null;
    if (callSpec) {
      const callMap = parseRangeSpecToFreqMap(normalizeSpec(callSpec));
      const allinMap = allinSpec ? parseRangeSpecToFreqMap(normalizeSpec(allinSpec)) : null;
      // Base = this player's 3bet range versus opener, so response is anchored correctly.
      const vsOpen = VS_OPEN?.[opener]?.[threeBettor] || null;
      const baseMap = vsOpen?.raiseSpec
        ? parseRangeSpecToFreqMap(normalizeSpec(vsOpen.raiseSpec))
        : {};
      const { actions, grid } = build13x13ResponseGridFromActionMaps({
        callFreqMap: callMap,
        raiseFreqMap: allinMap,
        baseFreqMap: baseMap,
        raiseActionLabel: "All in",
      });
      return {
        actions,
        grid,
        source: `${opener}_open_${threeBettor}_3bet_${opener}_4bet_${threeBettor}`,
      };
    }
  }

  // Open -> 3bet -> 4bet -> all in -> opener response (Call / Fold).
  if (
    history.length === 4 &&
    actionName(history[0]?.action) === "open" &&
    (actionName(history[1]?.action) === "3bet" || actionName(history[1]?.action) === "raise") &&
    (actionName(history[2]?.action) === "4bet" || actionName(history[2]?.action) === "raise") &&
    isAllInAction(history[3]?.action) &&
    actingPos === history[0]?.position
  ) {
    const opener = history[0]?.position;
    const threeBettor = history[1]?.position;
    const vs5bet = VS_5BET?.[opener]?.[threeBettor] || null;
    const callerCallSpec = vs5bet?.callSpec || null;
    if (callerCallSpec) {
      const callMap = parseRangeSpecToFreqMap(normalizeSpec(callerCallSpec));
      const vs3bet = VS_3BET?.[opener]?.[threeBettor] || null;
      const baseMap = vs3bet?.raiseSpec
        ? parseRangeSpecToFreqMap(normalizeSpec(vs3bet.raiseSpec))
        : {};
      const { actions, grid } = build13x13CallOnlyResponseGridFromActionMap({
        callFreqMap: callMap,
        baseFreqMap: baseMap,
      });
      return {
        actions,
        grid,
        source: `${opener}_open_${threeBettor}_3bet_${opener}_4bet_${threeBettor}_allin_${opener}`,
      };
    }
  }

  // LO/HI/CO/BTN/SB open -> remaining players react.
  if (
    history.length === 1 &&
    (history[0]?.position === "lj" || history[0]?.position === "hj" || history[0]?.position === "co" || history[0]?.position === "btn" || history[0]?.position === "sb") &&
    history[0]?.action === "open"
  ) {
    const opener = history[0]?.position;
    const cfg = VS_OPEN?.[opener]?.[actingPos] || null;
    if (cfg) {
      const callMap = cfg.callSpec ? parseRangeSpecToFreqMap(normalizeSpec(cfg.callSpec)) : null;
      const raiseMap = cfg.raiseSpec ? parseRangeSpecToFreqMap(normalizeSpec(cfg.raiseSpec)) : null;
      const { actions, grid } = build13x13ResponseGridFromActionMaps({
        callFreqMap: callMap,
        raiseFreqMap: raiseMap,
        raiseActionLabel: cfg.raiseActionLabel || "Raise 7.5",
      });
      return { actions, grid, source: `${opener}_open_${actingPos}` };
    }
  }

  // Open -> call -> remaining players react (squeeze/call trees).
  if (
    history.length === 2 &&
    actionName(history[0]?.action) === "open" &&
    actionName(history[1]?.action) === "call"
  ) {
    const opener = history[0]?.position;
    const caller = history[1]?.position;
    const cfg = VS_OPEN_CALL?.[opener]?.[caller]?.[actingPos] || null;
    if (cfg) {
      const callMap = cfg.callSpec ? parseRangeSpecToFreqMap(normalizeSpec(cfg.callSpec)) : null;
      const raiseMap = cfg.raiseSpec ? parseRangeSpecToFreqMap(normalizeSpec(cfg.raiseSpec)) : null;
      const { actions, grid } = build13x13ResponseGridFromActionMaps({
        callFreqMap: callMap,
        raiseFreqMap: raiseMap,
        raiseActionLabel: cfg.raiseActionLabel || "Raise 10",
      });
      return { actions, grid, source: `${opener}_open_${caller}_call_${actingPos}` };
    }
  }

  // Default: facing no prior betting -> open chart
  if ((preflopState?.raiseCount || 0) === 0 && actingPos) {
    const open = getOpenGridForPosition(actingPos);
    return { actions: open.actions, grid: open.grid, source: "open" };
  }

  return null;
}

